import { createSlice } from "@reduxjs/toolkit";

const editModalObjectInit = { id: null };
const modalsStructure = {
  delete: {
    open: false,
    id: null,
  },
  edit: {
    open: false,
    object: editModalObjectInit,
  },
};

const initialState = {
  sections: {
    category: { modals: { ...modalsStructure } },
    link: { modals: { ...modalsStructure } },
  },
};

const homePageCategoryControlSlice = createSlice({
  name: "homePageCategoryControl",
  initialState: initialState,
  reducers: {
    openDeleteModal: (state, action) => {
      const { section, id } = action.payload;
      state.sections[section].modals.delete = { open: true, id };
    },
    closeDeleteModal: (state, action) => {
      const { section } = action.payload;
      state.sections[section].modals.delete = { open: false, id: null };
    },
    openEditModal: (state, action) => {
      const { section, object } = action.payload;
      state.sections[section].modals.edit = { open: true, object };
    },
    closeEditModal: (state, action) => {
      const { section } = action.payload;
      state.sections[section].modals.edit = { open: false, object: editModalObjectInit };
    },
  },
});

export const { openDeleteModal, closeDeleteModal, openEditModal, closeEditModal } =
  homePageCategoryControlSlice.actions;
export default homePageCategoryControlSlice.reducer;
